import { fetcher } from '../fetcher'
import useSWR from 'swr'

export const usePostsByCatId = (cat_id: string) => {
  const { data, error, isLoading, mutate } = useSWR(
    cat_id ? `/posts/${cat_id}` : null,
    fetcher
  )

  return { data, error, isLoading, mutate }
}
